import { useNavigate } from 'react-router';

import { StatusScreenContent } from '~domains/partner-application/shared/ui/status-screen-content';

import { ampli } from '~shared/analytics';
import { ROUTES } from '~shared/config/routes';
import { Screen } from '~shared/ui/screen';

import { ButterflyMoney as ButterflyMoneyIllustration } from '@breezeventures/ui-kit/next/illustrations/medium/butterfly-money';

import { PartnerApplicationMenuHeader } from '../../partner-application-menu-header';

export const NoApplicationScreen = () => {
  const navigate = useNavigate();

  return (
    <Screen header={<PartnerApplicationMenuHeader />}>
      <StatusScreenContent
        icon={<ButterflyMoneyIllustration alt="" />}
        title={<>Tell&nbsp;us about your&nbsp;business, boss!</>}
        description={
          <>
            Share the&nbsp;main&nbsp;details to&nbsp;get
            your&nbsp;account&nbsp;ready.
          </>
        }
        action={{
          label: 'Start application',
          onClick: () => {
            ampli.mpPaStartApplicationClick();
            navigate(ROUTES.partner.application);
          },
        }}
      />
    </Screen>
  );
};
